const getEnvList = () => {
  return process.env.REACT_APP_ENV_NAME_LIST?.split(',') || [''];
};

const getAPIRoute = () => {
  return process.env.REACT_APP_ENV_API_LIST?.split(',')[Number(localStorage.getItem('env'))];
};

export { getAPIRoute, getEnvList };
